import { Routes, Route } from 'react-router-dom';
import Layout from './layouts/Layout';
import Overview from './pages/Overview';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Brands from './pages/Brands';
import Messages from './pages/Messages';
import Testimonials from './pages/Testimonials';
import Events from './pages/Events';
import Orders from './pages/Orders';
import Participants from './pages/Participants';
import Transactions from './pages/Transactions';
import TransactionLogs from './pages/TransactionLogs';
import Pages from './pages/Pages';
import Posts from './pages/Posts';
import ResourceTypes from './pages/ResourceTypes';
import Resources from './pages/Resources';
import FAQ from './pages/FAQ';
import Media from './pages/Media';
import Consultations from './pages/Consultations';
import Users from './pages/Users';
import Teams from './pages/Teams';
import Members from './pages/Members';
import Settings from './pages/Settings';

function App() {
  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Overview />} />
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/brands" element={<Brands />} />
        <Route path="/messages" element={<Messages />} />
        <Route path="/testimonials" element={<Testimonials />} />
        <Route path="/events" element={<Events />} />
        <Route path="/orders" element={<Orders />} />
        <Route path="/participants" element={<Participants />} />
        <Route path="/transactions" element={<Transactions />} />
        <Route path="/transaction-logs" element={<TransactionLogs />} />
        <Route path="/pages" element={<Pages />} />
        <Route path="/posts" element={<Posts />} />
        <Route path="/resource-types" element={<ResourceTypes />} />
        <Route path="/resources" element={<Resources />} />
        <Route path="/faq" element={<FAQ />} />
        <Route path="/media" element={<Media />} />
        <Route path="/consultations" element={<Consultations />} />
        <Route path="/users" element={<Users />} />
        <Route path="/teams" element={<Teams />} />
        <Route path="/members" element={<Members />} />
        <Route path="/settings" element={<Settings />} />
      </Routes>
    </Layout>
  );
}

export default App; 